import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Gift, CheckCircle, Star, Award, Briefcase, Users, BookOpen, Ticket, Download, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/Tabs';
export function BenefitsPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');
  const benefits = [{
    id: 1,
    category: 'membership',
    icon: Award,
    title: 'Sertifikat Keanggotaan Digital',
    description: 'Dapatkan sertifikat keanggotaan digital untuk keperluan profesional',
    status: 'available',
    action: 'Unduh Sertifikat'
  }, {
    id: 2,
    category: 'career',
    icon: Briefcase,
    title: 'Akses Bursa Lowongan Premium',
    description: 'Akses eksklusif ke lowongan kerja dari perusahaan teknologi terkemuka',
    status: 'available',
    action: 'Lihat Lowongan'
  }, {
    id: 3,
    category: 'learning',
    icon: BookOpen,
    title: 'Diskon Pelatihan & Workshop',
    description: 'Dapatkan diskon hingga 50% untuk pelatihan dan workshop ATIOS',
    status: 'available',
    discount: '50%',
    action: 'Lihat Pelatihan'
  }, {
    id: 4,
    category: 'networking',
    icon: Users,
    title: 'Acara Networking',
    description: 'Akses ke berbagai acara networking dan meetup dengan profesional IT',
    status: 'available',
    action: 'Lihat Acara'
  }, {
    id: 5,
    category: 'learning',
    icon: Star,
    title: 'Webinar Gratis',
    description: 'Akses gratis ke semua webinar dan seminar online ATIOS',
    status: 'available',
    action: 'Lihat Webinar'
  }, {
    id: 6,
    category: 'membership',
    icon: Ticket,
    title: 'Diskon Acara ATIOS',
    description: 'Diskon khusus untuk semua acara dan konferensi yang diselenggarakan ATIOS',
    status: 'available',
    discount: '30%',
    action: 'Lihat Acara'
  }, {
    id: 7,
    category: 'career',
    icon: Award,
    title: 'Sertifikasi Profesional',
    description: 'Akses ke program sertifikasi profesional dengan harga khusus anggota',
    status: 'coming-soon',
    action: 'Segera Hadir'
  }, {
    id: 8,
    category: 'networking',
    icon: Users,
    title: 'Program Mentoring',
    description: 'Kesempatan mendapat mentoring dari praktisi senior di industri teknologi',
    status: 'coming-soon',
    action: 'Segera Hadir'
  }];
  const filteredBenefits = activeTab === 'all' ? benefits : benefits.filter(b => b.category === activeTab);
  const stats = [{
    label: 'Total Manfaat',
    value: '12+',
    icon: Gift
  }, {
    label: 'Manfaat Aktif',
    value: '6',
    icon: CheckCircle
  }, {
    label: 'Manfaat Digunakan',
    value: '3',
    icon: Star
  }];
  return <div className="min-h-screen bg-white" data-id="element-1252">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-1253">
        {/* Header */}
        <div data-id="element-1254">
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1255">
            Manfaat Anggota
          </h1>
          <p className="text-neutral-600" data-id="element-1256">
            Nikmati berbagai manfaat eksklusif sebagai anggota ATIOS
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1257">
          {stats.map((stat, i) => <Card key={i} data-id="element-1258">
              <CardContent className="p-6" data-id="element-1259">
                <div className="flex items-center gap-4" data-id="element-1260">
                  <div className="h-12 w-12 rounded-lg bg-atios-light flex items-center justify-center" data-id="element-1261">
                    <stat.icon className="h-6 w-6 text-atios-primary" data-id="element-1262" />
                  </div>
                  <div data-id="element-1263">
                    <p className="text-2xl font-semibold text-neutral-900" data-id="element-1264">
                      {stat.value}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-1265">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Tabs */}
        <Tabs defaultValue="all" className="w-full" data-id="element-1266">
          <TabsList className="bg-neutral-100 border border-neutral-200" data-id="element-1267">
            <TabsTrigger value="all" onClick={() => setActiveTab('all')} data-id="element-1268">
              Semua Manfaat
            </TabsTrigger>
            <TabsTrigger value="membership" onClick={() => setActiveTab('membership')} data-id="element-1269">
              Keanggotaan
            </TabsTrigger>
            <TabsTrigger value="career" onClick={() => setActiveTab('career')} data-id="element-1270">
              Karir
            </TabsTrigger>
            <TabsTrigger value="learning" onClick={() => setActiveTab('learning')} data-id="element-1271">
              Pembelajaran
            </TabsTrigger>
            <TabsTrigger value="networking" onClick={() => setActiveTab('networking')} data-id="element-1272">
              Networking
            </TabsTrigger>
          </TabsList>

          <TabsContent value={activeTab} className="mt-6" data-id="element-1273">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1274">
              {filteredBenefits.map(benefit => <Card key={benefit.id} data-id="element-1275">
                  <CardHeader data-id="element-1276">
                    <div className="flex items-start justify-between mb-4" data-id="element-1277">
                      <div className="h-12 w-12 rounded-lg bg-atios-light flex items-center justify-center" data-id="element-1278">
                        <benefit.icon className="h-6 w-6 text-atios-primary" data-id="element-1279" />
                      </div>
                      {benefit.discount && <Badge variant="success" data-id="element-1280">
                          Diskon {benefit.discount}
                        </Badge>}
                      {benefit.status === 'coming-soon' && <Badge variant="warning" data-id="element-1281">Segera Hadir</Badge>}
                    </div>
                    <CardTitle className="text-base text-neutral-900" data-id="element-1282">
                      {benefit.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-1283">
                    <p className="text-sm text-neutral-600 mb-4" data-id="element-1284">
                      {benefit.description}
                    </p>
                    <Button className="w-full" size="sm" variant={benefit.status === 'coming-soon' ? 'secondary' : 'primary'} disabled={benefit.status === 'coming-soon'} data-id="element-1285">
                      {benefit.status === 'available' && <Download className="w-4 h-4 mr-2" data-id="element-1286" />}
                      {benefit.action}
                    </Button>
                  </CardContent>
                </Card>)}
            </div>
          </TabsContent>
        </Tabs>

        {/* CTA Section */}
        <Card className="bg-gradient-to-r from-atios-light to-white border-atios-primary/20" data-id="element-1287">
          <CardContent className="p-8" data-id="element-1288">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-1289">
              <div data-id="element-1290">
                <h3 className="text-xl font-semibold text-neutral-900 mb-2" data-id="element-1291">
                  Tingkatkan Keanggotaan Anda
                </h3>
                <p className="text-neutral-600" data-id="element-1292">
                  Dapatkan lebih banyak manfaat dengan upgrade ke keanggotaan
                  premium
                </p>
              </div>
              <Button size="lg" className="whitespace-nowrap" onClick={() => navigate('/membership/upgrade')} data-id="element-1293">
                Upgrade Sekarang <ExternalLink className="w-4 h-4 ml-2" data-id="element-1294" />
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}